import urlsService from '@services/urls-service';
import { api } from './api-service';

interface IAddressRequest {
  postalCode: string;
  houseNumber: string;
  houseNumberAddition?: string | undefined;
}

interface IAdressResponse {
  street: string;
  city: string;
}

export const getAddress = async (addressData: IAddressRequest) => {
  return api.post<IAdressResponse>({
    url: urlsService.getUrl('/address'),
    data: { ...addressData }
  });
};
